"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APTable = _interopRequireDefault(require("../common/APTable"));
var _PaddedDecimal = _interopRequireDefault(require("../common/PaddedDecimal/PaddedDecimal"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _dateHelper = require("../../helpers/dateHelper");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("./RecentTradesComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('recent-trades');
var RecentTradesComponent = function RecentTradesComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var selectedInstrument = props.selectedInstrument,
    recentTrades = props.recentTrades,
    fetching = props.fetching;
  var columns = [{
    header: t("Price"),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-price', row.TakerSide === 0 ? 'buy' : 'sell')
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: row.Price,
        bemMod: row.TakerSide === 0 ? 'buy' : 'sell',
        decimals: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)
      }));
    }
  }, {
    header: t("Qty"),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-qty')
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: row.Quantity,
        decimals: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement)
      }));
    }
  }, {
    header: t("Time"),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClass('table-time')
      }, (0, _dateHelper.formatTime)(row.Timestamp));
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    columns: columns,
    rows: recentTrades,
    baseClass: baseClass,
    empty: t("No recent trades"),
    fetching: fetching
  });
};
RecentTradesComponent.propTypes = {
  recentTrades: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    TradeId: _propTypes["default"].number.isRequired,
    TakerSide: _propTypes["default"].number.isRequired,
    Price: _propTypes["default"].object.isRequired,
    Quantity: _propTypes["default"].object.isRequired,
    Timestamp: _propTypes["default"].number.isRequired
  }))
};
RecentTradesComponent.defaultProps = {
  recentTrades: []
};
var _default = exports["default"] = RecentTradesComponent;